<template>
  <picture v-if="src && src.includes('.svg')" class="whitespace-normal">
    <BaseImage
      :image="image ? image : null"
      :classes="classes"
      :custom-scale="customScale"
      :is-inline="isInline"
    />
  </picture>
  <picture v-else class="whitespace-normal">
    <source
      media="(min-width: 737px)"
      :srcset="webpSrc()"
      type="image/webp"
      :alt="alt"
    />
    <source
      media="(min-width: 416px)"
      :srcset="`${webpSrc(736)} 1x, ${webpSrc(1472)} 2x`"
      type="image/webp"
      :alt="alt"
    />
    <source
      media="(max-width: 415px)"
      :srcset="`${webpSrc(415)} 1x, ${webpSrc(830)} 2x`"
      type="image/webp"
      :alt="alt"
    />
    <source
      media="(min-width: 737px)"
      :srcset="pngSrc()"
      type="image/png"
      :alt="alt"
    />
    <source
      media="(min-width: 416px)"
      :srcset="`${pngSrc(736)} 1x, ${pngSrc(1472)} 2x`"
      type="image/png"
      :alt="alt"
    />
    <source
      media="(max-width: 415px)"
      :srcset="`${pngSrc(415)} 1x, ${pngSrc(830)} 2x`"
      type="image/png"
      :alt="alt"
    />

    <BaseImage
      :image="image ? image : null"
      :classes="classes"
      :custom-scale="customScale"
      :is-inline="isInline"
    />
  </picture>
</template>
<script>
import BaseImage from "./BaseImage.vue";
export default {
  components: {
    BaseImage
  },
  props: {
    image: {
      type: Object,
      required: true
    },
    classes: {
      type: String,
      required: false,
      default: ""
    },
    isInline: {
      type: Boolean,
      required: false,
      default: false
    },
    customScale: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      webp: "fm=webp",
      png: "fm=png"
    };
  },
  computed: {
    src() {
      return this.image.image && this.image.image.fields.file
        ? this.image.image.fields.file.url
        : null;
    },
    alt() {
      return this.image && this.image.alt ? this.image.alt : "picture";
    }
  },
  methods: {
    quality() {
      return this.image.quality ? "&q=" + this.image.quality : "&q=" + "80";
    },
    height() {
      return this.image.height ? "&h=" + this.image.height : "";
    },
    sizeParams(w = null) {
      return this.quality() + this.width(w) + this.height();
    },
    webpSrc(w = null) {
      return this.customScale
        ? this.src + this.customScale
        : this.src + "?" + this.webp + this.sizeParams(w);
    },
    pngSrc(w = null) {
      return this.customScale
        ? this.src + this.customScale
        : this.src + "?" + this.png + this.sizeParams(w);
    },
    width(w = null) {
      if (this.image.width) {
        return "&w=" + this.image.width;
      } else if (w) {
        return "&w=" + w;
      } else {
        return "";
      }
    }
  }
};
</script>
